import React, { Fragment, useEffect, useState, useCallback } from "react";
import { set_products } from "../../../redux/actions/ProductsAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import { set_loading } from "../../../redux/actions/LayoutAction";
import TableList from "./TableList";
import Header from "../subheader/Header";
import { Redirect, useLocation } from "react-router-dom";
import ProductBulkImportModal from "../../../components/modal/ProductBulkImportModal";
import HeaderTab from "../order/tab/HeaderTab";
import "./productcatalog.scss";
import { debounce } from "lodash";
import { tabParam } from "../../../utils/utils";
var FileSaver = require('file-saver');

const ProductCatalog = (props) => {
  const location = useLocation();
  const [redirect, setRedirect] = useState(false);
  const [data, setData] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [headerList, setHeaderList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [store, setStore] = useState(null);

  const [currTab, setCurrTab] = useState("active");

  let message = "";
  const getProducts = (page, params) => {
    document.getElementById("rightContent").scrollTop = 0;
    setData(false);
    apiJson.products.getProducts(page, params).then((response) => {
      setData(true);
      if (response.success) {
        props.set_products({
          products: response.data.products,
          pagination: response.data.pagination,
        });
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(true);
      } else {
        setData(true);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  };

  const getStore = () => {
    apiJson.vendorProfile.getVendorProfile().then((response) => {
      setData(true);
      if (response.success) {
        setStore(response.data);
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(true);
      } else {
        setData(true);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }

  const showInfo = () => {
    toast.info(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const changeTab = (tabName) => {
    if (tabName.toLowerCase() !== currTab) {
      setCurrTab(tabName.toLowerCase());
      getProducts(
        1,
        tabParam(tabName.toLowerCase()) +
        (searchText?.length > 0 ? "&search_by_name=" + searchText : "")
      );
    }
  };

  const pageChange = (page) => {
    getProducts(
      page,
      tabParam(currTab) +
      (searchText?.length > 0 ? "&search_by_name=" + searchText : "")
    );
  };

  useEffect(() => {
    document.title = "Products";
  }, []);

  useEffect(() => {
    getStore();
    getProducts(
      1,
      tabParam(currTab) +
      (searchText?.length > 0 ? "&search_by_name=" + searchText : "")
    );
    apiJson.products.getTabsCount().then((response) => {
      response.success
        ? setHeaderList({
          id: "productlist",
          tablist: [
            { id: "active", count: response.data.active },
            { id: "inactive", count: response.data.inactive },
            {
              id: "uncategorized",
              count: response.data.uncategorized,
            },
          ],
        })
        : setHeaderList({
          id: "productlist",
          tablist: [
            { id: "active", count: 0 },
            { id: "inactive", count: 0 },
            { id: "uncategorized", count: 0 },
          ],
        });
    });
    // eslint-disable-next-line
  }, [location.state?.name]);

  const debouncedCallback =
    // eslint-disable-next-line
    useCallback(
      debounce((text, currTab) => handleSearch(text, currTab), 1000),
      []
    );

  const handleSearch = (text, tabName) => {
    getProducts(1, tabParam(tabName) + "&search_by_name=" + text);
  };

  const bulkImport = () => {
    setShowBulkModal(true);
  };

  const exportProducts = () => {
    message = "Exporting products. Please wait!";
    showInfo();
    setData(false);
    apiJson.export
      .exportProducts().then(response => {
        if (response.success) {
          const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
          FileSaver.saveAs(blob, "products.csv");
          message = "Products exported successfully.";
          showSuccess();
        }
        setData(true);
      });
  }

  const createClick = () => {
    setShowBulkModal(false);
  };

  const cancelClick = () => {
    setShowBulkModal(false);
  };

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      {showBulkModal && (
        <div className="product-import-modal-container">
          <ProductBulkImportModal
            heading="Bulk Import Product"
            cancleClick={cancelClick}
            createClick={createClick}
            dataType={"products"}
          />
        </div>
      )}
      <div className="vendor-page-right product-catalog-page-desktop">
        <Header
          heading="View Products"
          search={true}
          filters={null}
          handleSearch={(text) => {
            setSearchText(text);
            debouncedCallback(text, currTab);
          }}
        />
        <div className="right-content content-container-row">
          <div className="content mx-auto">
            <button
              type="button"
              className="create-button"
              onClick={() => setRedirect(true)}
            >
              Create New Product
            </button>
            <button
              type="button"
              className="create-button"
              onClick={bulkImport}
            >
              Bulk import Products
            </button>
            <button
              type="button"
              className="create-button"
              onClick={exportProducts}
            >
              Export All Products
            </button>
            <HeaderTab
              onTabChoose={changeTab}
              currTab={currTab}
              tab={headerList}
            >
              <TableList
                List={props.products}
                pageChange={pageChange}
                pagination={props.pagination}
                store={store}
              />
            </HeaderTab>
          </div>
        </div>
      </div>

      {redirect && (
        <Redirect
          push
          to={{ pathname: "/vendor/product/create", state: { name: "create" } }}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    pagination: state.product.pagination,
    products: state.product.products,
    load: state.layout.isLoading,
  };
};

const mapDispatchTopProps = { set_products, set_loading };

export default connect(mapStateToProps, mapDispatchTopProps)(ProductCatalog);
